//用于管理home模块的小仓库
import { defineStore } from 'pinia'  //引入创建pinia的方法

import { reqGetBannerList, reqGetProductShow } from '@/api'  //引入发送请求获取数据的方法

export const useHomeStore = defineStore('home', {
    //state：仓库存储数据的地方
    state: () => ({
        bannerList: [], //轮播图数据
        productShow: [],//产品展示数据
    }),

    //action：处理action，可以书写自己的业务逻辑,可以直接修改state
    actions: {
        //首页轮播图数据
        async getBannerList() {
            let result = await reqGetBannerList()
            if (result.code == 200) {
                this.bannerList = result.data
            }
        },
        //首页产品展示数据
        async getProductShow() {
            let result = await reqGetProductShow()
            if (result.code == 200) {
                this.productShow = result.data
            }
        },
    },

    //getters：可以理解为计算属性，用于简化仓库属性。让组件获取仓库数据更便捷
    getters: {

    }
})